var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9583 0.958333L15.1167 2.35833C15.3583 2.64167 15.5 3.01667 15.5 3.41667V13.8333C15.5 14.75 14.75 15.5 13.8333 15.5H2.16667C1.25 15.5 0.5 14.75 0.5 13.8333V3.41667C0.5 3.01667 0.641667 2.64167 0.883333 2.35833L2.03333 0.958333C2.26667 0.675 2.60833 0.5 3 0.5H13C13.3917 0.5 13.7333 0.675 13.9583 0.958333ZM3.41667 8L8 12.5833L12.5833 8H9.66667V6.33333H6.33333V8H3.41667ZM2.94167 1.33333L2.26667 2.16667H13.725L12.9417 1.33333H2.94167Z",
    fill: "#FF5555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkInActive);
export default __webpack_public_path__ + "static/media/mark_in_active.3e368424134ed45d093f5384d15807dc.svg";
export { ForwardRef as ReactComponent };